module.exports = __webpack_public_path__ + "static/media/esteban_cardozo.8144c47b.jpg";